import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Heading, Spinner, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { SlaForm } from '@/components/forms/SlaForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function SlaTimingEditPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!numericId || Number.isNaN(numericId)) {
      navigate('/service-catalog/sla-timing', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [numericId, navigate])

  const handleSuccess = () => {
    navigate('/service-catalog/sla-timing')
  }

  const handleCancel = () => {
    navigate('/service-catalog/sla-timing')
  }

  if (isValidating || !numericId) {
    return (
      <Box p={4} display="flex" alignItems="center" justifyContent="center" minH="200px">
        <Spinner size="lg" />
        <Text ml={3}>Loading...</Text>
      </Box>
    )
  }

  return (
    <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
      <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex="1">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit SLA</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update SLA rule details
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <SlaForm
              slaId={numericId}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </Box>
  )
}
